//GLOBAL - components from npm
import React from "react";

//STYLES
import "./micro-input-increase-decrease.css";

//COMPONENTS

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...
import { ReactComponent as IconSubtract } from "../../build/images/nps-dashboard-icons/subtract-icon.svg";
import { ReactComponent as IconAdd } from "../../build/images/nps-dashboard-icons/add-icon-new.svg";

export default function MicroInputIncreaseDecrease({
  value,
  label = "label",
  posLabel,
  onChangeValue,
  modifyRange = 1,
  negativeAllowed = false,
  maxValue,
  minValue,
}) {
  //GENERAL

  //STATES

  //REDUX - Selectors

  //FUNCTIONS
  const increaseValue = () => {
    if (maxValue) {
      if (Number(value) + modifyRange <= maxValue) {
        onChangeValue(Number(value) + modifyRange);
      }
    } else {
      onChangeValue(Number(value) + modifyRange);
    }
  };

  const decreaseValue = () => {
    if (value - modifyRange < 0 && negativeAllowed) {
      if (minValue) {
        if (value - modifyRange >= minValue) {
          onChangeValue(value - modifyRange);
        }
      } else {
        onChangeValue(value - modifyRange);
      }
    } else if (value - modifyRange >= 0) {
      if (minValue) {
        if (value - modifyRange >= minValue) {
          onChangeValue(value - modifyRange);
        }
      } else {
        onChangeValue(value - modifyRange);
      }
    }
  };

  //USE EFFECTS

  return (
    <div className="microinput-increase-decrease">
      <div
        className="microinput-increase-decrease__btn"
        onClick={() => decreaseValue()}
      >
        <IconSubtract />
      </div>

      <input readOnly type="text" value={`${value ? value : "0"}`} />

      <div
        className="microinput-increase-decrease__btn"
        onClick={() => increaseValue()}
      >
        <IconAdd />
      </div>
    </div>
  );
}
